<div class="feed-card">
  <!-- Header: Creator Info -->
  <div class="feed-header" *ngIf="feed.creator">
    <div class="avatar-container">
      <img [src]="feed.creator.url" *ngIf="feed.creator.url" class="circular">
      <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url"></ion-icon>
    </div>
    <div class="header-text">
      <div class="creator-name">{{feed.creator.name}}</div>
      <div class="post-date">{{feed.created_at | fancyDate}}</div>
    </div>
    <div class="more-options">
      <!-- Optional: Add more options menu here -->
    </div>
  </div>

  <!-- Main Image -->
  <div class="feed-image-container" (click)="viewFeedDetails()">
    <img [src]="feed.image_urls?.[0] || './assets/imgs/win.png'" class="feed-image">
  </div>

  <!-- Actions Bar -->
  <div class="feed-actions">
    <div class="action-btn heart" (click)="showEmojiBox = !showEmojiBox">
      <ion-icon [name]="showEmojiBox ? 'heart' : 'heart-outline'"></ion-icon>
    </div>
    <div class="action-btn" (click)="viewFeedDetails()">
      <ion-icon name="chatbubble-outline"></ion-icon>
    </div>
    <div class="action-btn whatsapp" (click)="feedService.share(feed)">
      <ion-icon name="logo-whatsapp"></ion-icon>
    </div>
  </div>

  <!-- Reactions Summary -->
  <div class="reaction-summary" *ngIf="feed.reactionKeys?.length">
    <div class="reaction-pill" *ngFor="let key of feed.reactionKeys">
      <span>{{key}}</span>
      <b>{{feed.reaction_count[key]}}</b>
    </div>
  </div>

  <!-- Content Section -->
  <div class="feed-content" (click)="viewFeedDetails()">
    <span class="feed-title">{{feed.header}}</span>
    <div class="feed-description" [class.truncated]="!details" [innerHTML]="feed.description | linebreaks"></div>
  </div>

  <!-- Emoji Picker Overlay -->
  <div class="emoji-picker-overlay" *ngIf="showEmojiBox">
    <div class="emoji-item" *ngFor="let emoji of reactionService.emojiList" (click)="clickEmoji(emoji)">
      {{emoji}}
    </div>
  </div>
</div>